import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHCargoDel = async (credentials, data) => {
    const body = {
        service: "RNHCargoDel",
        params: {
            rnhCargoId: data?.id || null,
            rnhCargoVersion: data?.version
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
